// Foundations
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AnalyticsService } from 'src/app/services/analytics.service';
import {PackageService} from '../../../services/package.service';

@Component({
  selector: 'app-package-confirm',
  templateUrl: './package-confirm.component.html',
  styleUrls: ['./package-confirm.component.scss'],
})
export class PackageConfirmComponent implements OnInit {

  @Input() completedOrderId: string;

  @Output() changeStep = new EventEmitter<number>();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _analytics: AnalyticsService,
    public packageService: PackageService
  ) {}

  ngOnInit(): void {}

  // Public Methods
  // ------------------------------------------------------------------------------------

  navigateToLandingPage(): void {
    this._analytics.logButtonTap('package_returnToLanding');
    this.router.navigate(['/']);
  }
}
